import axios from 'axios';
import { API_URL, pollingSubscription } from './adapters';

// Backed by /api/animations. This collection is API-only, so it already uses
// the camelCase field names the pages expect and needs no field translation.

const toAnimation = (doc) => {
  if (!doc) return null;
  return { ...doc, id: doc._id };
};

export const getAllAnimations = async () => {
  const { data } = await axios.get(`${API_URL}/animations`);
  return data.map(toAnimation);
};

export const getAnimation = async (animationId) => {
  try {
    const { data } = await axios.get(`${API_URL}/animations/${animationId}`);
    return toAnimation(data);
  } catch (error) {
    if (error.response?.status === 404) return null;
    throw error;
  }
};

export const getActiveAnimationForDevice = async (deviceId, companyId) => {
  if (!companyId || !deviceId) return null;
  const { data } = await axios.get(`${API_URL}/animations/active/${companyId}/${deviceId}`);
  return toAnimation(data);
};

export const createAnimation = async (animationData) => {
  const { data } = await axios.post(`${API_URL}/animations`, {
    companyId: animationData.companyId,
    animationUrl: animationData.animationUrl,
    targetDevices: animationData.targetDevices || [],
    isActive: animationData.isActive !== false,
    expiresAt: animationData.expiresAt || null
  });
  return toAnimation(data);
};

export const updateAnimation = async (animationId, updates) => {
  const { data } = await axios.put(`${API_URL}/animations/${animationId}`, updates);
  return toAnimation(data);
};

export const deactivateAnimation = async (animationId) => {
  await updateAnimation(animationId, { isActive: false });
  return true;
};

export const deleteAnimation = async (animationId) => {
  await axios.delete(`${API_URL}/animations/${animationId}`);
  return true;
};

// Expiry is enforced by a MongoDB TTL index on expiresAt, so there is nothing
// for the client to sweep. Kept so existing call sites keep working.
export const cleanupExpiredAnimations = async () => 0;

export const subscribeToAllAnimations = (callback) =>
  pollingSubscription(getAllAnimations, callback);
